import { useEffect, useRef, useState } from "react";

// Note: returns true for `durationMs` whenever `key` changes to a new non-null
// value, skipping the initial mount. Used to flash a "just updated" affordance
// on dashboard cards when periodic refetches bring genuinely new data (the key
// is a fingerprint of the latest values, so unchanged refetches don't flash).
export function useJustUpdated(key: string | number | null, durationMs = 1500): boolean {
  const [justUpdated, setJustUpdated] = useState(false);
  const previousKey = useRef<string | number | null>(null);
  const initialised = useRef(false);

  useEffect(() => {
    if (!initialised.current) {
      initialised.current = true;
      previousKey.current = key;
      return;
    }

    if (key === previousKey.current) return;
    previousKey.current = key;
    if (key === null) return;

    setJustUpdated(true);
    const timer = setTimeout(() => setJustUpdated(false), durationMs);
    return () => clearTimeout(timer);
  }, [key, durationMs]);

  return justUpdated;
}
